import React from "react";
import ChipSelector, { ChipOption } from "../../../common/form/ChipSelect/ChipSelector";
import CustomText from "../../../common/general/CustomText/CustomText";

interface Props {
  value: string[];
  onChange: (v: string[]) => void;
}

const careerOptions: ChipOption[] = [
  {
    key: "software_engineering",
    value: "Software Engineering",
    icon: <CustomText text="🧑‍💻" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "medicine",
    value: "Medicine",
    icon: <CustomText text="🩺" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "finance",
    value: "Finance",
    icon: <CustomText text="📈" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "research",
    value: "Research",
    icon: <CustomText text="🧪" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "teaching",
    value: "Teaching",
    icon: <CustomText text="🧑‍🏫" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "design",
    value: "Design",
    icon: <CustomText text="🎨" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "ai_data_science",
    value: "AI & Data Science",
    icon: <CustomText text="🤖" size="m" useTranslationText={false} style={undefined} />,
  },
  { key: "law", value: "Law", icon: <CustomText text="⚖️" size="m" useTranslationText={false} style={undefined} /> },
  {
    key: "engineering",
    value: "Engineering",
    icon: <CustomText text="🛠️" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "marketing",
    value: "Marketing",
    icon: <CustomText text="📣" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "arts_media",
    value: "Arts & Media",
    icon: <CustomText text="🎬" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "public_service",
    value: "Public Service",
    icon: <CustomText text="🤝" size="m" useTranslationText={false} style={undefined} />,
  },
];

export default function CareerInterestsEditor({ value, onChange }: Props) {
  return <ChipSelector options={careerOptions} selectedKeys={value ?? []} onSelectionChange={onChange} multiSelect />;
}
